import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout, getParentLayout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'
import { NO_RESET_WHITE_LIST } from '@/constants'

const { t } = useI18n()
export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    redirect: '/dashboard/analysis',
    name: 'Dashboard',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'analysis',
        component: () => import('@/views/Pages/dataOverViews/Analysis.vue'),
        name: 'Analysis',
        meta: {
          title: t('router.analysis'),
          noCache: true,
          affix: true
        }
      },
      {
        path: 'workplace',
        component: () => import('@/views/Pages/dataOverViews/Analysis.vue'),
        name: 'Workplace',
        meta: {
          title: t('router.workplace'),
          noCache: true
        }
      }
    ]
  },
  {
    path: '/count',
    component: Layout,
    redirect: '/count/content',
    name: 'Count',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'content',
        component: () => import('@/views/Pages/Count/index.vue'),
        name: 'count-content',
        meta: {
          title: '统计报告',
          noCache: true,
          affix: true
        }
      }
    ]
  },
  {
    path: '/practice',
    component: Layout,
    redirect: '/practice/select',
    name: 'Practice',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      // {
      //   path: 'test',
      //   component: () => import('@/views/Pages/Practice/test/index.vue'),
      //   name: 'practice-test',
      //   meta: {
      //     title: '测试用页',
      //     noCache: true,
      //     affix: true,
      //     menu: true
      //   }
      // },
      {
        path: 'select',
        component: () => import('@/views/Pages/Practice/select/index.vue'),
        name: 'practice-select',
        meta: {
          title: '选课',
          noCache: true,
          affix: true,
          menu: true
        },
        children: [
          {
            path: 'detail/:id',
            component: () => import('@/views/Pages/Practice/select/components/LessonDetail.vue'),
            name: 'practice-detail',
            meta: {
              title: '课程详情',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'submit',
            component: () => import('@/views/Pages/Practice/select/components/submit.vue'),
            name: 'practice-submit',
            meta: {
              title: '提交课程',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'config',
            component: () => import('@/views/Pages/Practice/select/components/LessonConfig.vue'),
            name: 'practice-config',
            meta: {
              title: '配置课程',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'class',
        component: () => import('@/views/Pages/Practice/class/index.vue'),
        name: 'practice-class',
        meta: {
          title: '课班管理',
          noCache: true,
          affix: true,
          menu: true
        },
        children: [
          {
            path: 'detail/:id',
            component: () => import('@/views/Pages/Practice/class/components/ClassDetail.vue'),
            name: 'practice-class-detail',
            meta: {
              title: '课班详情',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'teacher',
        component: () => import('@/views/Pages/Practice/teacher/index.vue'),
        name: 'practice-teacher',
        meta: {
          title: '老师管理',
          noCache: true,
          affix: true,
          menu: true
        },
        children: [
          {
            path: 'detail/:id',
            component: () => import('@/views/Pages/Practice/teacher/components/TeacherDetail.vue'),
            name: 'practice-teacher-detail',
            meta: {
              title: '老师详情',
              noCache: true,
              affix: true
            }
          },
          {
            path: 'add',
            component: () => import('@/views/Pages/Practice/teacher/components/AddTeacher.vue'),
            name: 'practice-add-teacher',
            meta: {
              title: '新增老师',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'custom',
        component: () => import('@/views/Pages/Practice/custom/index.vue'),
        name: 'practice-custom',
        meta: {
          title: '自定义',
          noCache: true,
          affix: true,
          menu: true
        },
        children: [
          {
            path: 'add',
            component: () => import('@/views/Pages/Practice/custom/AddClass.vue'),
            name: 'practice-add-class',
            meta: {
              title: '新增课程',
              noCache: true,
              affix: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/base',
    component: Layout,
    redirect: '/base/class',
    name: 'Base',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'class',
        component: () => import('@/views/Pages/Base/class/index.vue'),
        name: 'base-class',
        meta: {
          title: '班级信息',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'student',
        component: () => import('@/views/Pages/Base/student/index.vue'),
        name: 'base-student',
        meta: {
          title: '学生信息',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'classroom',
        component: () => import('@/views/Pages/Base/classroom/index.vue'),
        name: 'base-classroom',
        meta: {
          title: '教室信息',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'material',
        component: () => import('@/views/Pages/Base/material/index.vue'),
        name: 'base-material',
        meta: {
          title: '材料信息',
          noCache: true,
          affix: true,
          menu: true
        },
        children: [
          {
            path: 'detail/:id',
            component: () => import('@/views/Pages/Base/material/components/MaterialDetail.vue'),
            name: 'base-material-detail',
            meta: {
              title: '材料详情',
              noCache: true,
              affix: true
            }
          }
        ]
      },
      {
        path: 'activity',
        component: () => import('@/views/Pages/Base/activity/index.vue'),
        name: 'base-activity',
        meta: {
          title: '活动审批',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'lessons',
        component: () => import('@/views/Pages/Base/lessons/index.vue'),
        name: 'base-lessons',
        meta: {
          title: '上课时间',
          noCache: true,
          affix: true,
          menu: true
        }
      }
    ]
  },
  {
    path: '/aiWork',
    component: Layout,
    redirect: '/aiWork/scheduling',
    name: 'Ai-Work',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'scheduling',
        component: () => import('@/views/Pages/AIWork/scheduling/index.vue'),
        name: 'ai-work-scheduling',
        meta: {
          title: '排课',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'clock',
        component: () => import('@/views/Pages/AIWork/clock/index.vue'),
        name: 'ai-work-clock',
        meta: {
          title: '老师打卡',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'work',
        component: () => import('@/views/Pages/AIWork/work/index.vue'),
        name: 'ai-work-work',
        meta: {
          title: '作业统计',
          noCache: true,
          affix: true,
          menu: true
        }
      },
      {
        path: 'analyse',
        component: () => import('@/views/Pages/AIWork/analyse/index.vue'),
        name: 'ai-work-analyse',
        meta: {
          title: '学情分析',
          noCache: true,
          affix: true,
          menu: true
        }
      }
    ]
  },
  {
    path: '/tool',
    component: Layout,
    redirect: '/tool/content',
    name: 'Tool',
    meta: {
      title: t('router.dashboard'),
      icon: 'vi-ant-design:dashboard-filled',
      alwaysShow: true
    },
    children: [
      {
        path: 'content',
        component: () => import('@/views/Pages/Tool/index.vue'),
        name: 'tool-content',
        meta: {
          title: '工具内容',
          noCache: true,
          affix: true
        }
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: '/error/404',
    name: 'Error',
    meta: {
      title: t('router.errorPage'),
      icon: 'vi-ci:error',
      alwaysShow: true
    },
    children: [
      {
        path: '404-demo',
        component: () => import('@/views/Error/404.vue'),
        name: '404Demo',
        meta: {
          title: '404'
        }
      },
      {
        path: '403-demo',
        component: () => import('@/views/Error/403.vue'),
        name: '403Demo',
        meta: {
          title: '403'
        }
      },
      {
        path: '500-demo',
        component: () => import('@/views/Error/500.vue'),
        name: '500Demo',
        meta: {
          title: '500'
        }
      }
    ]
  }
]

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/practice/select',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectWrap',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/register',
    component: () => import('@/views/Login/components/RegisterStepOne.vue'),
    name: 'register-step-one',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/personal',
    component: Layout,
    redirect: '/personal/personal-center',
    name: 'Personal',
    meta: {
      title: t('router.personal'),
      hidden: true,
      canTo: true
    },
    children: [
      {
        path: 'personal-center',
        component: () => import('@/views/Personal/PersonalCenter/PersonalCenter.vue'),
        name: 'PersonalCenter',
        meta: {
          title: t('router.personalCenter'),
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
